import React, { Fragment } from 'react'

// Components Global
import { Row, Column } from '../../../../../../../components/Columns'
import { BtnModalOpen } from '../../../../../../../components/Modals/BtnModal'
import BtnManager from '../../../../../../../components/BtnManager'

// Components Pages
import PageTemplateCreateModal from '../../../PageTemplateCreateModal'
import PageTemplateUpdateModal from '../../../PageTemplateUpdateModal'

// Actions Redux
import { closeModal } from '../../../../../../../redux/App/AppActions'

// Fuctions
import { onDelete } from '../../../../../../../redux/Pages/PagesFunctions'

//css
import css from './css/templateLists.css'


const TemplateLists = (props) => {
  const lang = props.lang || 'local'
  let { title, pages, templateType, history, urlMainManage } = props
  pages = pages.filter(page => page.type === 'template' && page.templateType === templateType)

  const goto = (pages_id) => {
    props.dispatch(closeModal(`pageTemplateManageModal`))
    history.push(`${urlMainManage}/page-template-manage/${pages_id}`)
  }

  return (
    <div>
      <PageTemplateCreateModal {...props} />

      <div style={{ borderBottom: '1px solid #e6e6e6' }}>
        <Row className="pd-bottom-10 pd-top-10">
          <Column col="column col-xxs-12 col-xs-6">
            <div className="pd-right-10 pd-top-3">
              <span>{ title }</span>
            </div>
          </Column>
          <Column col="column col-xxs-12 col-xs-6 text-right">
            <BtnModalOpen id={`${templateType}-pageTemplateCreateModal`}>
              <button className="waves-effect btn-shadow-none waves-light btn btn-xs pd-right-10">
                <i className="material-icons left">add</i> เพิ่มรูปแบบ
              </button>
            </BtnModalOpen>
          </Column>
        </Row>
      </div>

      <div className={css.boxLists}>
        { pages.length !== 0 ?
          <div>
            { pages.map(page => {
              return (
                <div key={page._id} className={css.list}>
                  <div className={css.name}>{page.name[lang]}</div>
                  <div className={css.manage}>
                    <a onClick={() => goto(page._id)} className="btn btn-shadow-none btn-xxs mg-right-5">ออกแบบ</a>

                    <BtnModalOpen id={`${page._id}-pageTemplateUpdateModal`}>
                      <a className="btn btn-shadow-none btn-xxs btn-edit mg-right-5">
                        <i className="material-icons">edit</i>
                      </a>
                    </BtnModalOpen>

                    <BtnManager
                      iconOnly
                      id={page._id}
                      btnSize="btn-xxs"
                      className="dp-inline-block"
                      manager={[
                        {
                          type: 'delete',
                          show: true,
                          label: 'ลบ',
                          title: `ลบ "รูปแบบนี้" อย่างถาวร`,
                          msg: `กดปุ่ม "รูปแบบนี้" ถ้าคุณต้องการลบหน้า "รูปแบบนี้" อย่างถาวร`,
                          labelConfirm: 'รูปแบบนี้',
                          handle: onDelete(props),
                        }
                      ]}
                    />
                  </div>

                  <PageTemplateUpdateModal {...props} page={page} />
                </div>
              )
            }) }
          </div>
        :
          <div className="pd-top-50 text-center">ไม่มีรูปแบบเทมเพลต</div>
        }
      </div>
    </div>
  )
}

export default TemplateLists
